// Consent-gated analytics control (Phase 6A).
// PostHog only starts when the visitor's stored choice permits it
// (`cookie_consent.functional === true`). index.html exposes
// window.__shsEnableAnalytics; it never auto-inits without consent.

export const enableAnalytics = () => {
  try { window.__shsEnableAnalytics?.(); } catch { /* analytics unavailable */ }
};

export const disableAnalytics = () => {
  try { window.posthog?.opt_out_capturing?.(); } catch { /* not loaded */ }
  // Clear only site-controlled PostHog identifiers. Platform cookies
  // (__cf_bm, __emg_vid, __emg_sid) are not ours and are left untouched.
  try {
    document.cookie.split(";").forEach((c) => {
      const name = c.split("=")[0].trim();
      if (name.startsWith("ph_")) {
        document.cookie = `${name}=; Max-Age=0; path=/`;
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname}`;
        document.cookie = `${name}=; Max-Age=0; path=/; domain=.${window.location.hostname}`;
      }
    });
  } catch { /* cookie access blocked */ }
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith("ph_"))
      .forEach((k) => localStorage.removeItem(k));
  } catch { /* storage unavailable */ }
};

export const applyAnalyticsConsent = (permitted) => {
  if (permitted) enableAnalytics();
  else disableAnalytics();
};
